import { ModuleModel } from '../../module.model.interface';
import { ApiMessageDescriptor } from './api.message';
import { ProfileModel } from '../../profile/model/profile.model';

export class MessageModel extends ApiMessageDescriptor implements ModuleModel {
  public discriminator = 'MessageDescriptor';

  public createdByDetail?: ProfileModel;
  public createdByFullName?: string;

  constructor(o?: ApiMessageDescriptor) {
    super();

    if (o) {
      this.id = o.id;
      this.content = o.content;
      this.created = o.created;
      this.createdBy = o.createdBy;
      this.visibleUntil = o.visibleUntil;
      this.visibleFrom = o.visibleFrom;
      this.subject = o.subject;
      this.href = o.href;
      this.modified = o.modified;
      this.deleted = o.deleted;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/help.message/model/message.model.ts